import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Bookmark, Filter } from 'lucide-react';
import ContentGrid from '../components/common/ContentGrid';
import { demoPosts, demoArticles, demoVideos } from '../data/demoData';
import { useShare } from '../hooks/useShare';

const contentTypes = ['All', 'Posts', 'Articles', 'Videos'];

export default function BookmarksPage() {
  const { theme } = useTheme();
  const handleShare = useShare();
  const [selectedType, setSelectedType] = useState('All');

  // Simulate bookmarked content
  const bookmarkedContent = [...demoPosts.slice(0, 3), ...demoArticles.slice(0, 3), ...demoVideos.slice(0, 3)]
    .filter(content => {
      if (selectedType === 'All') return true;
      return content.type === selectedType.toLowerCase().slice(0, -1);
    });

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <Bookmark className="h-8 w-8 text-blue-500" />
          <h1 className={`text-2xl font-bold ${
            theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
          }`}>
            Saved Items
          </h1>
        </div>
      </div>

      <div className="flex items-center space-x-4">
        <select
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
          className={`
            px-4 py-2 rounded-lg border focus:ring-2 focus:ring-blue-500 focus:outline-none
            ${theme === 'dark'
              ? 'bg-gray-800 border-gray-700 text-gray-100'
              : 'bg-white border-gray-200 text-gray-900'
            }
          `}
        >
          {contentTypes.map(type => (
            <option key={type} value={type}>{type}</option>
          ))}
        </select>
      </div>

      <ContentGrid
        items={bookmarkedContent}
        onLike={(id) => {
          console.log('Liked content:', id);
        }}
        onShare={async (id) => {
          const content = bookmarkedContent.find(item => item.id === id);
          if (content) {
            await handleShare(content);
          }
        }}
      />
    </div>
  );
}